export enum GameStatus {
    LIVE = 'Live',
    WATCHING = 'Watching',
    UPCOMING = 'Upcoming',
}
